module.exports = __webpack_public_path__ + "static/img/14.45d7a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/14.png
// module id = CJUk
// module chunks = 0